<b>{{localized["title"]}}</b>
<mat-label *ngIf="showConfirmation">{{localized["confirmationText"]}}</mat-label>
<mat-spinner *ngIf="waiting"></mat-spinner>
<form [formGroup]="appointmentForm" (ngSubmit)="onSubmit(appointmentForm.value)" *ngIf="!showConfirmation">

  <mat-vertical-stepper formArrayName="formArray" linear>
    <mat-step formGroupName="0" [stepControl]="formArray?.get([0])">
      <ng-template matStepLabel>{{localized["myHairdresser"]}}:
        {{(selectedHairdresser=='Any')?localized['any']:selectedHairdresser}}</ng-template>
      <mat-form-field>
        <mat-label>{{localized["kapper"]}}</mat-label>
        <mat-select formControlName="hairdresserCtrl"
          (selectionChange)="selectedHairdresser=$event.value;resetSelection($event)" [(ngModel)]="selectedHairdresser">
          <mat-option value="Any">{{localized["any"]}}</mat-option>
          <mat-option value="Nathalie">Nathalie</mat-option>
          <mat-option value="Kurt">Kurt</mat-option>
        </mat-select>
      </mat-form-field>
      <div>
        <button mat-button matStepperNext type="button">{{localized["next"]}}</button>
      </div>
    </mat-step>

    <mat-step formGroupName="1" [stepControl]="formArray?.get([1])">
      <ng-template matStepLabel>{{localized["service"]}}: {{selectedServiceTranslatedName}}</ng-template>
      <mat-form-field>
        <mat-label>{{localized["selectService"]}}</mat-label>
        <mat-select formControlName="serviceCtrl"
          (selectionChange)="selectedServiceTranslatedName=$event.value.translatedName;selectedServiceName=$event.value.name;resetSelection($event)">
          <mat-option *ngFor="let service of masterData.services" [value]="service">
            {{service.translatedName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="selectedServiceName=='color'||selectedServiceName=='all-in'">
        <div>
          <section>
            <mat-checkbox formControlName="longHairCtrl" [(ngModel)]="longHair" (change)="resetSelection($event)">
              {{localized['hairHight']}}</mat-checkbox>
          </section>
        </div>
        <div>
          <section>
            <mat-checkbox formControlName="highlightCtrl" [(ngModel)]="highLight" (change)="resetSelection($event)">
              {{localized['highlights']}}</mat-checkbox>
          </section>
        </div>
      </div>
      <div>
        <button type="button" mat-button matStepperPrevious>{{localized["back"]}}</button>
        <button mat-button matStepperNext type="button">{{localized["next"]}}</button>
      </div>
    </mat-step>

    <mat-step formGroupName="2" [stepControl]="formArray?.get([2])">
      <ng-template matStepLabel>{{localized["appointmentDate"]}}: {{ selectedDate.FormatDate()}}</ng-template>
      <mat-form-field>
        <input matInput formControlName="dateCtrl" [matDatepicker]="picker" placeholder="{{localized['datum']}}"
          (dateInput)="selectedDate=$event.value" [matDatepickerFilter]="calendarFilter" [value]="selectedDate"
          [min]="selectedDate" (dateChange)="selectedDateChanged($event)">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <div>
        <button type="button" mat-button matStepperPrevious>{{localized["back"]}}</button>
        <button type="button" mat-button matStepperNext>{{localized["next"]}}</button>
      </div>
    </mat-step>

    <mat-step formGroupName="3" [stepControl]="formArray?.get([3])">
      <ng-template matStepLabel>{{localized["appointmentTime"]}}: {{selectedTime}}</ng-template>
      <mat-form-field>
        <mat-label>{{localized["tijd"]}}</mat-label>
        <mat-select formControlName="timeCtrl" (selectionChange)="selectedTime=$event.value">
          <mat-option *ngFor="let time of timeList" [value]="time">
            {{time.toString()}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div>
        <button type="button" mat-button matStepperPrevious>{{localized["back"]}}</button>
        <button type="button" mat-button matStepperNext>{{localized["next"]}}</button>
      </div>
    </mat-step>

    <mat-step formGroupName="4" [stepControl]="formArray?.get([4])">
      <ng-template matStepLabel>{{localized["info"]}}</ng-template>
      <mat-form-field>
        <input matInput placeholder="{{localized['naam']}}" formControlName="nameCtrl">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="{{localized['email']}}" formControlName="emailCtrl">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="{{localized['telefoon']}}" formControlName="phoneCtrl">
      </mat-form-field>

      <div>
        <button type="button" mat-button matStepperPrevious>{{localized["back"]}}</button>
        <button type="button" mat-button matStepperNext>{{localized["next"]}}</button>
      </div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>{{localized["appointmentConfirmation"]}}</ng-template>
      <mat-label [innerHTML]=""></mat-label>
      <div>
        <button mat-raised-button type="submit">{{localized["submit"]}}</button>
        <button type="button" mat-button (click)="formArray.reset()">{{localized["reset"]}}</button>
      </div>
    </mat-step>
  </mat-vertical-stepper>
</form>
